"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Weekdays = exports.Week = void 0;

var _preact = require("preact");

var Week = function Week(_ref) {
  var children = _ref.children,
      key = _ref.key;
  return (0, _preact.h)("div", {
    className: "a-week",
    key: key
  }, children);
};

exports.Week = Week;

var Weekdays = function Weekdays() {
  var weekdays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  return (0, _preact.h)("div", {
    className: "m-weekdays"
  }, weekdays.map(function (week, idx) {
    return (0, _preact.h)(Week, {
      key: idx
    }, week);
  }));
};

exports.Weekdays = Weekdays;